'use client';

import { useTranslations } from 'next-intl';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const benefitKeys = ['benefit1', 'benefit2', 'benefit3', 'benefit4'] as const;

export function SolutionSection() {
  const t = useTranslations('creator.personalBrandBot.solution');

  return (
    <Box sx={{ py: { xs: 6, md: 8 } }}>
      <Container maxWidth="md" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h4"
          component="h2"
          fontWeight={700}
          sx={{ mb: 2 }}
        >
          {t('title')}
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4, maxWidth: 560, mx: 'auto' }}
        >
          {t('subtitle')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            alignItems: 'center',
          }}
        >
          {benefitKeys.map((key) => (
            <Box
              key={key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
              }}
            >
              <CheckCircleIcon sx={{ color: 'success.main', fontSize: 24 }} />
              <Typography variant="body1" fontWeight={500}>
                {t(key)}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
